import { Component, OnInit } from '@angular/core';
import { GeneratedcoverlettersService } from './services/generatedcoverletters.service';
import { GeneratedCoverLetterModel } from './models/gen-cover-letters/generate-cls-model';
import { environment } from 'src/environments/environment';
import { ImageService } from 'src/app/services/image/image.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-generatedcoverletters',
  templateUrl: './generatedcoverletters.component.html',
  styleUrls: ['./generatedcoverletters.component.css'],
})
export class GeneratedcoverlettersComponent implements OnInit {
  constructor(
    private generatedclService: GeneratedcoverlettersService,
    private imageService: ImageService,
    private router: Router
  ) {}
  generatedCls: GeneratedCoverLetterModel[] = [];
  clImageUrls: { [key: string]: string } = {};
  mainURL = 'assets/cls/';
  imagePath = environment.apiUrl + this.mainURL;

  ngOnInit(): void {
    this.generatedclService.getGeneratedCls().subscribe((generatedcls: any) => {
      this.generatedCls = generatedcls;
      // console.log(this.generatedCls);
      this.loadAllImages();
    });
  }

  disableRightClick(event: MouseEvent) {
    event.preventDefault();
  }

  downloadFile(path: string) {
    const fullUrl = this.imagePath + path;
    const fileName = path.split('/').pop() || 'download';

    this.imageService.getSecureImage(fullUrl).subscribe({
      next: (blobUrl) => {
        // Create a temporary link and trigger download
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
      },
      error: (err) => {
        console.error('Error downloading file:', err);
        alert('Failed to download file. Please try again.');
      },
    });
  }

  makeOrder(clId: string, type: string) {
    this.router.navigate(['/payment'], {
      state: {
        productKey: type,
        serviceSystemId: clId,
      },
      queryParams: {
        productKey: type,
        serviceSystemId: clId,
      },
    });
  }

  loadAllImages() {
    this.generatedCls.forEach((cv) => {
      if (cv.imagePath) {
        const fullImageUrl = this.imagePath + cv.imagePath;

        this.imageService.getSecureImage(fullImageUrl).subscribe({
          next: (blobUrl) => {
            this.clImageUrls[fullImageUrl] = blobUrl;
          },
          error: (err) => {
            console.error('Error loading image:', err);
          },
        });
      }
    });
  }

  getImageUrl(imageLink: string): string {
    const fullImageUrl = this.imagePath + imageLink;
    return this.clImageUrls[fullImageUrl] || 'assets/img/placeholder.png';
  }
}
